import { styled } from '@material-ui/core/styles'
import { Email } from '@material-ui/icons'

export const SessionEmail = styled(Email)({
  color: '#b6bec8'
})
